<table  id="print-section" class="table table-bordered">

 <script type="text/javascript">
        window.onload = addPageNumbers;

        function addPageNumbers() {
            var totalPages = Math.ceil(document.body.scrollHeight / 1123);  //842px A4 pageheight for 72dpi, 1123px A4 pageheight for 96dpi, 
            for (var i = 1; i <= totalPages; i++) {
                var pageNumberDiv = document.createElement("div");
                var pageNumber = document.createTextNode(" पृष्ठ क्र. " + i + " of " + totalPages);
                pageNumberDiv.style.position = "absolute";
                pageNumberDiv.style.marginTop = "calc((" + i + " * (297mm - 0.5px)) - 40px)"; //297mm A4 pageheight; 0,5px unknown needed necessary correction value; additional wanted 40px margin from bottom(own element height included)
                pageNumberDiv.style.height = "16px";
                pageNumberDiv.appendChild(pageNumber);
                document.body.insertBefore(pageNumberDiv, document.getElementById("content"));
                pageNumberDiv.style.left = "calc(100% - (" + pageNumberDiv.offsetWidth + "px + 20px))";
            }
        }
    </script>

    <thead>
        <tr>
            <th style="font-size: 14px;">वर्गणी बाकी असलेले
                <div style="font-size: 14px; font-weight: 600; margin-bottom: 4px;" class="noPrint">
                    <span *ngIf="start_date">पासुन दिनांक: {{ start_date | date:'dd-MM-yyyy' }} | </span>
                    <span *ngIf="end_date">पर्यत दिनांक: {{ end_date | date:'dd-MM-yyyy' }} | </span>
                    <span *ngIf="country">देश: {{ country }} | </span>
                    <span *ngIf="state">राज्य: {{ state }} | </span>
                    <span *ngIf="district">जिल्हा: {{ district }} | </span>
                    <span *ngIf="taluka">तालुका: {{ taluka }} | </span>
                    <span *ngIf="rep_name">प्रतिनिधी: {{ rep_name }} | </span>
                    <span *ngIf="delivery_mode">वितरण मोड: {{ delivery_mode }} | </span>
                    <span *ngIf="sub_type">सदस्यता प्रकार: {{ sub_type }} | </span>
                    <span *ngIf="prant_name">प्रांत: {{ prant_name }}</span>
                  </div>
            </th>
        </tr>
    </thead>

    <tbody>
        <div class="row" style="margin-top: 1%;">

          <ng-container  *ngFor="let data1 of PendingAdd; let i = index"  style="page-break-inside: avoid;">
            <div class="col-md-12" style="text-align: center; font-size: 17px;">
                {{data1.rep_name}} - {{data1.rep_taluka}}
            </div>
            <div class="col-3" style="padding: 40px; font-weight: 40px; font-size: 15px;"*ngFor="let data2 of data1.rep_data,; let i1 = index">
             <b>   {{data2.sub_no}}<br> {{data2.name}} <br> {{data2.address}} <br>{{data2.taluka}} <br> {{data2.district}} - {{data2.pincode}} {{data2.state}} <br>
                 मो.क्र. - {{data2.mobileNumber}} </b>
            </div>
          </ng-container>


           

        </div>

        <!-- <tr *ngFor="let data1 of PendingAdd; let i = index">
            <td>{{data1.rep_name}}</td>
            <td *ngFor="let data2 of data1.rep_data,; let i1 = index">
                <div>
                    {{data2.name}} ,<br> {{data2.address}} , <br> {{data2.pincode}} , {{data2.country}} , {{data2.state}} , <br> {{data2.taluka}} , {{data2.district}} . <br> 
                    {{data2.mobileNumber}} , {{data2.telephone}}
                </div> <br>
            </td>
        </tr> -->

        <!-- <tr *ngFor="let row of generateRows(PendingAdd, 6)">
            <td *ngFor="let item of row.rep_data">
                <div>
                    {{item.name}} ,<br> {{item.address}} , <br> {{item.pincode}} , {{item.country}} , {{item.state}} , <br> {{item.taluka}} , {{item.district}} . <br> 
                    {{item.mobileNumber}} , {{item.telephone}}
                </div> <br>
            </td>
        </tr> -->

    </tbody>

</table>

<div style="margin-left: 50%;  margin-bottom: 2%">
    <!-- <button class="noPrint" style="margin-top: 2% 2% 0 2%;"
    (click)="exportExcel('Representativewise_Address_Label_Report')" mat-raised-button color="primary">
    Export
    </button> -->

    <button
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'12px', 'font-weight':'400', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'15px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
        class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"   [useExistingCss]="true"

        printSectionId="print-section" ngxPrint>
        Print
    </button>
    <button mat-dialog-close class="btn noPrint">
        Close
    </button>
</div>



  